module.exports = __webpack_public_path__ + "static/media/10.4be25f9a.jpg";